import { render, staticRenderFns } from "./directions.vue?vue&type=template&id=71370e7a&"
import script from "./directions.vue?vue&type=script&lang=js&"
export * from "./directions.vue?vue&type=script&lang=js&"
import style0 from "./directions.vue?vue&type=style&index=0&id=71370e7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseOrnamentBg: require('/opt/yamal.ru/src/components/base/ornament-bg.vue').default,DirectionImageCard: require('/opt/yamal.ru/src/components/direction/image-card.vue').default,RzContainer: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/container/index.vue').default})
